import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import axios from 'axios';

import Button from '../../Button/Button';
import ImageEditorLink from '../../../pages/NotPageFound/ImageEditorLink';
import InputEmoji from '../../Form/Input/InputEmoji';
import Input from '../../Form/Input/Input';
import Loader from '../../Loader/Loader';
import GroupUpladPreview from './GroupUploadPreview';
// import { talkFileUpload } from '../../../util/talk-upload';

// import { 
//   createCompressedImage,
//   generateBase64FromImage,
// } from '../../../util/image';

import {
  createImagePreviews,
} from '../../../util/talk/talk-file';

import { useStore } from '../../../hook-store/store';

import { 
  KURASTORAGE_URL,
  KURAIMAGEPHOTO_URL,
} from '../../../App';

import { marks } from '../../../images/marks';
import classes from './GroupUpload.module.css';

const GroupUploadFromKuraInfo = props => {
  // console.log('VideoTextTalkUpload.js-props', props);
  const { 
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  // const userData = store.userData;

  const kuraStorageLink = (
    <a href={KURASTORAGE_URL}
      target='_blank' rel="noreferrer noopener"
    >
      Kura Storage
    </a>
  );

  const kuraImagePhotoLink = (
    <a href={KURAIMAGEPHOTO_URL}
      target='_blank' rel="noreferrer noopener"
    >
      Kura Image Photo
    </a>
  );

  let groupUploadFromKuraInfoBody;
  
  groupUploadFromKuraInfoBody = (
    <div>
      <div className={classes.talkUploadTitle}>
        {t('groupTalk.text76', 'Use stored file')}
        
      </div>
      <p>
        {t('groupTalk.text77', 'It is possible to create post using stored files')}
        {' '}at {' '}
        {kuraStorageLink} or {kuraImagePhotoLink}.
      </p>
      <p>
        {t('groupTalk.text78', 'Other users can access and download your file from this page, and talk about the file using text chat.')}
      </p>
      <p>
        {kuraStorageLink}{' '}
        {t('groupTalk.text79', 'is simple file storage with various tools for files.')}
        {t('groupTalk.text80', 'It has editing and generation tools for text and audio data. It has communication tools with other users including video talk.')}
      </p>
      <p>
        {kuraImagePhotoLink}{' '}
        {t('groupTalk.text81', 'is simple image file storage space with various image editing and generation tools.')}
      </p>
      </div>
    );

    
  return (
    <Fragment>
      <div>{groupUploadFromKuraInfoBody}</div>
    </Fragment>

  );
}

export default GroupUploadFromKuraInfo;